import React from 'react';

import styles from './index.module.scss';
import WarningSvg from '../icons/Warning';

interface WarningProps {
  title: string;
  message: string;
}

export const Warning: React.FC<WarningProps> = (props: WarningProps) => {
  return (
    <div className={styles.container}>
      <WarningSvg />
      <div>
        <h1>{props.title}</h1>
        <p>{props.message}</p>
      </div>
    </div>
  );
};
